/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetSignedAssetURLForm = {
  /**
   * The ID of the function asset
   */
  assetId: string;
};

/** @internal */
export type GetSignedAssetURLForm$Outbound = {
  asset_id: string;
};

/** @internal */
export const GetSignedAssetURLForm$outboundSchema: z.ZodMiniType<
  GetSignedAssetURLForm$Outbound,
  GetSignedAssetURLForm
> = z.pipe(
  z.object({
    assetId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      assetId: "asset_id",
    });
  }),
);

export function getSignedAssetURLFormToJSON(
  getSignedAssetURLForm: GetSignedAssetURLForm,
): string {
  return JSON.stringify(
    GetSignedAssetURLForm$outboundSchema.parse(getSignedAssetURLForm),
  );
}
